import { Button, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import MainContainer from "../components/ContainerComponents/MainContainer";

const Missing = () => {
    return <MainContainer>
        <Row>
            Hoppsan, sidan du försöker nå finns inte...
        </Row>
        <Row>
            <Link to="/"><Button>Gå hem</Button></Link>
        </Row>
    </MainContainer>
}

export default Missing;